import {Model} from './Model';

export class BannerNotification extends Model {
  static override resource = 'banner-notification';

  content!: string;
  created_at!: string;
  updated_at!: string;
  expiry_date!: string;
  background_colour!: string;
  is_active!: boolean;
  type!: string;

  constructor(values: object) {
    super(values);
    (<any> Object).assign(this, values);
  }

}
